<template>
  <page-view class="tms-shell-order tms-style">
    <div slot="pageRight">
      <div class="order-search">
        <div style="display: flex;justify-content: space-between;">
            <div class="title" style="display: flex; padding-bottom: 16px">
            <span
                style="color: #9c9c9c; cursor: pointer"
                @click="toDashboard"
            >{{ $t('RailwayFreight.Railway.DataStatistics') }}</span
            >
            <div
                style="width: 2px; margin: 3px 8px; background-color: #9c9c9c"
            ></div>
            <span style="color: #59b9d3"> {{ $t('RailwayFreight.Railway.OrderInquiry') }}</span>
            </div>
            <div class="scription-center" @click="showScription()"><i class="el-icon-collection" style="margin-right: 4px;"></i>{{ $t('RailwayFreight.Railway.SubscriptionCenter') }}</div>
        </div>
        <div class="flex">
          <el-form
            style="flex: 1"
            ref="pageInfo"
            :model="pageInfo"
            label-width="100px"
          >
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('RailwayFreight.Railway.CustomerConsignmentNo')" label-width="200px">
                  <el-input
                    size="small"
                    v-model="pageInfo.attorneyNo"
                    :placeholder="$t('RailwayFreight.Railway.Placeholder')"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('RailwayFreight.Railway.OrderNumber')" label-width="200px">
                  <el-input
                    size="small"
                    v-model="pageInfo.orderNoExactly"
                    :placeholder="$t('RailwayFreight.Railway.Placeholder')"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('RailwayFreight.Railway.ContainerNo')" label-width="200px">
                  <el-input
                    size="small"
                    v-model="pageInfo.cntrNo"
                    :placeholder="$t('RailwayFreight.Railway.Placeholder')"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('RailwayFreight.Railway.OrderPlacementPeriod')" label-width="200px">
                  <el-date-picker
                    v-model="bookTimeRange"
                    type="daterange"
                    style="width:100%"
                    :range-separator="'-'"
                    :start-placeholder="$t('RailwayFreight.Railway.EnterDate')"
                    :end-placeholder="$t('RailwayFreight.Railway.EnterDate')"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    size="small"
                    class="custom-input"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="text-align: center;margin-top: 20px;">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  :loading="fullscreenLoading"
                  @click="toQueryOrder"
                >{{ $t('RailwayFreight.Railway.Search') }}</el-button
                >
                <el-button
                  size="small"
                  icon="el-icon-refresh-right"
                  :loading="fullscreenLoading"
                  @click="reset"
                >{{ $t('RailwayFreight.Railway.Reset') }}
                </el-button>
                <el-button
                  size="small"
                  icon="el-icon-download"
                  :loading="fullscreenLoading"
                  @click="exportOrder"
                >{{ $t('RailwayFreight.Railway.Export') }}</el-button
                >
              </el-col>
            </el-row>
          </el-form>
          <!--
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              :loading="fullscreenLoading"
              @click="toQueryOrder"
            >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              :loading="fullscreenLoading"
              @click="reset"
            >重置
            </el-button>
            <el-button
              size="small"
              icon="el-icon-download"
              :loading="fullscreenLoading"
              @click="exportOrder"
            >导出</el-button
            >
          </div>
          -->
        </div>
      </div>
      <div
        class="order-list"
        v-loading="fullscreenLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(196,196,204, 0.8)"
      >
        <div class="list-type">
          <div class="title">{{ $t('RailwayFreight.Railway.DetailsView') }}</div>
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="showType === 'card' ? $t('RailwayFreight.Railway.SwitchToList'): $t('RailwayFreight.Railway.SwitchToCard')" placement="bottom">
            <img v-if="showType === 'card'" src="@/assets/tms/order_list_card.png" @click="changeDisplayGrid('table')"/>
            <img v-else src="@/assets/tms/order_list_table.png" @click="changeDisplayGrid('card')"/>
          </el-tooltip>
        </div>
        <div v-if="showType === 'card'">
          <Collapse v-if="orderList && orderList.length" :value="expandPanel">
            <Panel
              v-for="(item, index) in orderList"
              :key="index"
              class="list-item"
              :name="item.orderNo"
            >
              <div slot="header" @click="displayExtensionInfo(item)">
                <img
                  class="header_icon"
                  src="@/assets/tms/order_item_icon.png"
                />
                <div class="order-no">{{ $t('RailwayFreight.Railway.CustomerConsignmentNo') }}：{{ item.attorneyNo }}</div>
                <div class="order-head-infomation">
                  <Description
                    style="flex: 1"
                    :content="`${$t('RailwayFreight.Railway.TransportationTerms')}：${item.freightTerms}`"
                  />
                  <Description
                    style="flex: 1"
                    :content="`${$t('RailwayFreight.Railway.OrderPlacementTime')}：${formatDate(item.bookTime)}`"
                  />
                  <Description
                    style="flex: 1"
                    :content="`${$t('RailwayFreight.Railway.OrderNumber')}：${item.orderNo}`"
                  />
                  <Description style="flex: 1" />
                </div>
              </div>
              <div slot="content">
                <div class="detail-info">
                  <div class="detail-info-status"></div>
                  <div class="detail-info-content">
                    <div style="display: flex;column-gap: 32px;">
                      <Description v-if="firstType === 'RD' && item.freightTerms.includes('DOOR-')"
                        style="flex: 2"
                        :label="$t('RailwayFreight.Railway.Departure')"
                        :content="item.departure"
                      />
                      <Description v-if="firstType === 'RD' && item.freightTerms.includes('-DOOR')"
                        style="flex: 2"
                        :label="$t('RailwayFreight.Railway.Arrival')"
                        :content="item.destination"
                      />
                      <Description
                        style="flex: 3"
                        :label="item.freightTerms && item.freightTerms.includes('DOOR-') ? $t('RailwayFreight.Railway.LoadingAddress') : $t('RailwayFreight.Railway.Departure')"
                        :content="item.freightTerms && item.freightTerms.includes('DOOR-') ? item.consignorInfo: item.departure"
                      />
                      <Description
                        style="flex: 3"
                        :label="item.freightTerms && item.freightTerms.includes('-DOOR') ? $t('RailwayFreight.Railway.UnloadingAddress') : $t('RailwayFreight.Railway.Arrival')"
                        :content="item.freightTerms && item.freightTerms.includes('-DOOR') ? item.consigneeInfo : item.destination"
                      />
                    </div>
                    <div style="display: flex; margin-top: 12px;column-gap: 32px;">
                      <Description
                        style="flex: 4"
                        :label="$t('RailwayFreight.Railway.ProductName')"
                        :content="item.cargoInfo"
                      />
                      <Description
                        style="flex: 2"
                        :label="$t('RailwayFreight.Railway.TotalWeight')"
                        :content="item.grossWeight"
                      />
                      <Description
                        style="flex: 2"
                        :label="$t('RailwayFreight.Railway.ContainerTypeQuantity')"
                        :content="item.containerInfo"
                      />
                    </div>
                    <div style="display: flex; margin-top: 12px;column-gap: 32px;">
                      <Description
                        style="flex: 8"
                        :label="$t('RailwayFreight.Railway.ContainerNo')"
                        :content="cntrRefer[item.id]"
                      />
                    </div>
                    <div class="order-step" v-if="stageRefer[item.id] && stageRefer[item.id].length > 0">
                      <div
                        class="order-step-item" v-for="(stageInfo, stageIndex) in stageRefer[item.id]" :key="stageIndex">
                        <div class="satus-name">
                          <p :class="[stageInfo.over ? 'name': 'grey-name']">{{ stageInfo.stageAttribute }}</p>
                          <div v-show="stageIndex < (stageRefer[item.id].length - 1)" class="flex" style="margin-left: 36px">
                            <div
                              style="width: 90px;border-top:2px dashed;margin-top: 6px;"
                              :style="{borderColor: stageInfo.over ? '#59b9d3' : '#E9ECF2' }"
                            ></div>
                            <i class="el-icon-caret-right" :style="{color: stageInfo.over ? '#59b9d3' : '#E9ECF2'}"></i>
                          </div>
                        </div>
                        <div class="status-time">{{ stageInfo.stageValue ? formatDate(stageInfo.stageValue) : '' }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="track-btn">
                    <el-tooltip
                      v-if="!epodRefer[item.id] || epodRefer[item.id].length === 0"
                      effect="dark"
                      :content="$t('RailwayFreight.Railway.NoReceipt')"
                      :disabled="true"
                      :enterable="false"
                      placement="bottom">
                      <span>
                        <el-button
                          type="primary"
                          disabled
                          plain
                          size="small"
                          style="margin-left: 0px; width: 100%; margin-top: 8px"
                        >
                        {{ $t('RailwayFreight.Railway.NoReceipt') }}
                        </el-button>
                      </span>
                    </el-tooltip>
                    <el-button
                      v-else
                      type="primary"
                      plain
                      size="small"
                      style="margin-left: 0px; width: 100%; margin-top: 8px"
                      @click="displayEpod(item)"
                    >
                      {{ $t('RailwayFreight.Railway.ViewReceipts') }}
                    </el-button>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
          <div v-else style="text-align: center; padding: 20px">{{ $t('RailwayFreight.Railway.NoData') }}</div>
        </div>
        <el-table v-else ref="orderTable" :data="orderList" style="width: 100%">
          <el-table-column type="index" width="80" :label="$t('RailwayFreight.Railway.Number')"></el-table-column>
          <el-table-column prop="orderNo" width="150" :label="$t('RailwayFreight.Railway.OrderNumber')"></el-table-column>
          <el-table-column prop="attorneyNo" width="220" :label="$t('RailwayFreight.Railway.CustomerConsignmentNo')"></el-table-column>
          <el-table-column prop="freightTerms" width="200" :label="$t('RailwayFreight.Railway.TransportationTerms')"> </el-table-column>
          <el-table-column prop="cargoInfo" width="220" show-overflow-tooltip :label="$t('RailwayFreight.Railway.ProductName')"> </el-table-column>
          <el-table-column prop="grossWeight" width="200" :label="$t('RailwayFreight.Railway.TotalWeight')"> </el-table-column>
          <el-table-column prop="numberOfPackage" width="200" show-overflow-tooltip :label="$t('RailwayFreight.Railway.NumberOfPackage')"> </el-table-column>
          <el-table-column prop="containerInfo" width="200" show-overflow-tooltip :label="$t('RailwayFreight.Railway.ContainerTypeQuantity')"> </el-table-column>
          <el-table-column prop="consignorInfo" width="220" show-overflow-tooltip :label="$t('RailwayFreight.Railway.LoadingAddress')"> </el-table-column>
          <el-table-column prop="consigneeInfo" width="220" show-overflow-tooltip :label="$t('RailwayFreight.Railway.UnloadingAddress')"> </el-table-column>
          <el-table-column width="100" :label="$t('RailwayFreight.Railway.Operation')" fixed="right">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-info">
        <div style="color:#999;font-size: 12px;margin-left: 220px;"></div>
        <el-pagination
          v-show="orderList && orderList.length"
          :page-size="pageInfo.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="prev,sizes, pager, next"
          @current-change="currentChange"
          @size-change="handleSizeChange"
          :total="pageInfo.totalCount"
        >
        </el-pagination>
      </div>

      <el-dialog
        custom-class="receipt-dialog"
        :title="$t('RailwayFreight.Railway.ViewReceipts')"
        :visible.sync="epodVisible"
        width="50%"
      >
        <div v-for="epod in epodInfoes" :key="epod.id" class="receipt-img">
          <div v-if="imageTypes.includes(judgeType(epod))">
            <img style="width:100%;height:100%;object-fit: contain;" :src="epod.filePath" />
            <div class="opeartor">
              <el-button
                type="primary"
                size="small"
                style="margin-left: 0px; width: 100%; margin-top: 8px"
                @click="downloadEpod(epod,'回单')"
              >
              {{ $t('RailwayFreight.Railway.Download') }}
              </el-button>
            </div>
          </div>
          <div v-else style="margin-top: 32px;">
            <img style="width:64px;height:64px;margin-bottom: 8px;" src="@/assets/tms/unknown_file.png" />
            <div>{{ $t('RailwayFreight.Railway.NotSupportedPreview') }}</div>
            <div> {{ $t('RailwayFreight.Railway.YouCan') }} <a @click="downloadEpod(epod,'回单文件')">{{ $t('RailwayFreight.Railway.Download') }}</a></div>
          </div>
        </div>
      </el-dialog>
      <div class="foot-tip">
        <i class="el-icon-warning-outline"></i>
        {{ $t('RailwayFreight.Railway.Declaration') }}
      </div>
      <ScriptCenter ref="scriptCenter" @success="$refs.SubscriptionSuccess.open()"/>
      <SubscriptionSuccess ref="SubscriptionSuccess" />
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import { Collapse, Panel } from '@/components/OrderCollapse'
import Description from '@/components/Description'
import i18n from '@/i18n/i18n'
import moment from 'moment'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import {
  getOrderExtensionInfo,
  getOrderList,
  doneOrderExport
} from '@/api/rms'

export default {
  components: {
    PageView,
    Collapse,
    Panel,
    Description,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {
    return {
      firstType: '',
      orderList: [],
      stageRefer: {},
      cntrRefer: {},
      epodRefer: {},
      epodInfoes: [],
      epodVisible: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      bookTimeRange: [],
      fullscreenLoading: false,
      imageTypes: ['jpg', 'png', 'jpeg', 'gif'],
      showType: 'card',
      expandPanel: [],
      milestoneRefer: {
        提货时间: 'PickUpTime',
        预计发运时间: 'EstimatedShippingTime',
        实际发运时间: 'ActualShippingTime',
        预计到站时间: 'EstimatedArrivalTime',
        实际到站时间: 'ActualArrivalTime',
        预计送货时间: 'EstimatedDeliveryTime',
        送货时间: 'DeliveryTime'
      },
      langRefer: {
        en: 'en_US',
        zh: 'zh_CN'
      }
    }
  },
  watch: {
    /**
    stageRefer: {
      handler(newValue, oldValue) {
        this.expandPanel = this.orderList.map((item) => {
          return item.orderNo;
        })
      }
    }
     */
  },
  created() {
    this.firstType = this.$route.meta.firstType;
    this.pageInfo.firstType = this.firstType
  },
  mounted() {
    this.queryOrder();
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    judgeType(file) {
      if (!file) return
      const _index = file.fileName.lastIndexOf('.')
      const src = file.fileName.slice(_index + 1)
      return src
    },
    queryOrder() {
      this.orderList = [];
      this.stageRefer = {};
      this.cntrRefer = {};
      this.fullscreenLoading = true;
      if ( this.bookTimeRange.length === 2) {
        this.pageInfo.bookTimeStart = this.bookTimeRange[0];
        this.pageInfo.bookTimeEnd = this.bookTimeRange[1];
      }
      getOrderList(this.pageInfo).then( resp => {
        this.orderList = resp.data.results;
        this.orderList.forEach(item => {
          this.displayExtensionInfo(item);
        });
        this.pageInfo.totalCount = resp.data.totalCount;
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
      });
    },
    toQueryOrder() {
      this.pageInfo.pageNo = 1;
      this.queryOrder();
    },
    currentChange(value) {
      this.pageInfo.pageNo = value;
      this.queryOrder();
    },
    handleSizeChange(value) {
      this.pageInfo.pageSize = value;
      this.queryOrder();
    },
    displayExtensionInfo(item) {
      getOrderExtensionInfo(item.id).then(resp => {
        const stageInfoList = resp.data.stageInfoes;
        stageInfoList.forEach(item => {
            if(item.stageAttribute.indexOf('预计') > -1){
              item.stageValue = null;
              item.over = false;
            }
            item.stageAttribute = this.$t('RailwayFreight.Railway.' + this.milestoneRefer[item.stageAttribute]);
        });
        this.$set(this.stageRefer, item.id, stageInfoList);
        const cntrInfoes = resp.data.cntrInfoes.map(item => {
          return item.cntrNo;
        }).join(',');
        this.$set(this.cntrRefer, item.id, cntrInfoes);
        this.$set(this.epodRefer, item.id, resp.data.epodInfoes);
        this.$forceUpdate(); // 强制刷新数据，不然不会更新dom
      });
    },
    displayEpod(item) {
      this.epodInfoes = this.epodRefer[item.id];
      if (this.epodInfoes && this.epodInfoes.length > 0) {
        this.epodVisible = true;
      }
    },
    previewEpod(oosInfo) {
      //
    },
    downloadEpod(oosInfo) {
      window.open(oosInfo.filePath);
    },
    reset() {
      this.pageInfo = {
        pageNo: 1,
        pageSize: 10,
        firstType: this.firstType
      };
      this.bookTimeRange = [];
    },
    toDashboard() {
      this.$router.push({
        name: 'railway' + this.firstType + 'Dashbaord'
      })
    },
    exportOrder() {
      console.log('EXPORT');
      this.pageInfo.lang = this.langRefer[this.$ls.get('lang')];
      doneOrderExport(this.pageInfo).then(resp => {
        // window.open(resp.data.filePath, '_blank');
        this.onDownLoadFile(resp.data.filePath, 'RailwayFreight_Export_' + moment(new Date()).format('YYYYMMDD') + '.xls');
      });
    },
    changeDisplayGrid(type) {
      this.showType = type
      this.queryOrder();
    },
    onDownLoadFile(url, filename) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, filename)
      })
    },
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response)
        }
      }
      xhr.send()
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      }
      else {
        var link = document.createElement('a')
        var body = document.querySelector('body')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.style.display = 'none'
        body.appendChild(link)
        link.click()
        body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }
    },
    showScription() {
      const type = this.$route.meta.firstType
      this.$refs.scriptCenter.open('RMS_' + type)
    },
  }
}
</script>
<style lang="less">
.tms-shell-order {
  padding: 10px;
  background: #f0f6fb;
  position: relative;
  margin-bottom: 50px;
  .plr25 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .ptb25 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
    .scription-center {
        border: 1px solid #53a2b6;
        color: #53a2b6;
        height: 30px;
        line-height: 18px;
        border-radius: 4px;
        padding:4px 16px;
        cursor: pointer;
    }
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height: 60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .list-type {
    display: flex;
    justify-content: space-between;
    img {
      width: 20px;
      height: 20px;
      display: inline-block;
      cursor: pointer;
      transition: all 0.5s ease 0.1s;
    }
    img:hover {
      transform: scale(1.3);
    }
  }
  .header_icon {
    width: 34px;
    height: 34px;
    display: inline-block;
  }
  .order-no {
    font-size: 16px;
    font-weight: 400;
    color: #111827;
    margin-left: 18px;
    display: inline-block;
  }
  .order-head-infomation {
    padding-left: 52px;
    display: flex;
    justify-content: flex;
  }
  .detail-info {
    border-radius: 10px;
    // border: 1px solid #e9ecf2;
    padding: 16px 0;
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #f6f6f8;
    .detail-info-status {
      background: #59b9d3;
      width: 3px;
      margin-left: -1px;
      border-radius: 0 16px 16px 0;
    }
    .detail-info-content {
      flex: 1;
      margin-left: 20px;
    }
    .track-btn {
      width: 108px;
      margin-right: 30px;
    }
  }
  .pagination-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 40px;
    background: #fff;
    text-align: right;
    padding: 8px 16px;
    z-index: 3;
  }
  .el-pager li.active{
    background-color: #59b9d3;
    color: #fff;
    border-radius: 2px;
  }
  .receipt-img {
    border:1px solid #c1c1c1;
    border-radius: 4px;
    margin-bottom: 8px;
    text-align: center;
    position: relative;
    min-height: 180px;
  }
  .receipt-dialog {
    .el-dialog__body {
        height: 70vh;
        overflow-y: scroll;
        padding:10px;
        padding-right: 0;
    }
  }
  .opeartor {
    width:80px;
    position: absolute;
    right:8px;
    top:8px;
  }
}

.order-step {
  display: flex;
  padding: 20px 0px;
  img {
    width: 34px;
    height: 34px;
    display: inline-block;
    margin-right: 8px;
  }
  .order-step-item {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .satus-name {
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 12px;
      font-weight: 600;
      color: #111827;
    }
    .grey-name {
      font-size: 12px;
      font-weight: 600;
      color: #9ca3af;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
    }
  }
  .status-time {
    font-size: 10px;
    font-weight: 500;
    color: #9ca3af;
    line-height: 14px;
  }
}

.foot-tip {
    height: 36px;
    line-height: 36px;
    background-color: #F0F6FC;
    color: #8CA2BD;
    font-size: 12px;
    opacity: 0.85;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0px;
    padding-left: 208px;
  }
</style>
